import { DropDownCategories } from 'src/types/generic';

export const GLCodeCategories: DropDownCategories[] = [
  { value: 0, label: 'Show All' },
  { value: 1, label: 'Show Active/Inactive' },
  { value: 2, label: 'Show Deleted' },
];

export const MemberCategories: DropDownCategories[] = [
  { value: 0, label: 'Show All' },
  { value: 1, label: 'Show Active' },
  { value: 2, label: 'Show Disabled' },
];

export const useGLCodeCategories = () => {
  const categories = [...GLCodeCategories];
  return categories;
};
export const useMemberCategories = () => {
  const categories = [...MemberCategories];
  return categories;
};
